import { SCHOOLS, SENIOR_CATEGORIES, BRAND } from "../constants";
import { INPUT_STYLE, LABEL_STYLE } from "../styles/shared.js";

export default function TributeFormStep({
  fromName, onFromNameChange, entry, onEntryChange,
  tributeNumber, maxTributes, submittedTributes, failedTributes, onRetry,
}) {
  var sc = submittedTributes ? submittedTributes.length : 0;
  var hasSubmitted = sc > 0;

  return (
    <div>
      <div style={{ display: "flex", alignItems: "center", gap: "12px", marginBottom: "4px" }}>
        <h2 style={{ fontFamily: "'Playfair Display', serif", fontSize: "20px", margin: 0, color: "#1A1A1A", fontWeight: 800 }}>
          {hasSubmitted ? "Write Another Tribute" : "Write a Tribute"}
        </h2>
        {tributeNumber && maxTributes && (
          <span style={{
            background: "#F3E8FF", color: BRAND.primary, fontSize: "12px", fontWeight: 600,
            padding: "3px 10px", borderRadius: "12px", whiteSpace: "nowrap",
          }}>
            {"Tribute " + tributeNumber + " of " + maxTributes}
          </span>
        )}
      </div>
      <p style={{ fontSize: "13px", color: "#888", margin: "0 0 16px" }}>
        {hasSubmitted
          ? (maxTributes - sc) + " tribute" + (maxTributes - sc !== 1 ? "s" : "") + " remaining."
          : "Thank a teacher, staff member, or honor a 2026 senior."}
      </p>

      {/* Submitted tributes list */}
      {submittedTributes && submittedTributes.length > 0 && (
        <div style={{ marginBottom: "16px" }}>
          {submittedTributes.map(function (t) {
            return (
              <div key={t.id} style={{
                display: "flex", alignItems: "center", gap: "10px",
                background: "#E8F5E9", borderLeft: "3px solid #4CAF50",
                padding: "8px 12px", marginBottom: "6px", borderRadius: "4px",
              }}>
                <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="#4CAF50" strokeWidth="3" strokeLinecap="round" strokeLinejoin="round">
                  <polyline points="20 6 9 17 4 12" />
                </svg>
                <span style={{ fontSize: "13px", color: "#333" }}>
                  <strong>{t.teacher}</strong>{t.school ? " — " + t.school : ""}
                </span>
              </div>
            );
          })}
        </div>
      )}

      {/* Failed tributes list */}
      {failedTributes && failedTributes.length > 0 && (
        <div style={{ marginBottom: "16px" }}>
          {failedTributes.map(function (t) {
            return (
              <div key={t.id} style={{
                display: "flex", alignItems: "center", gap: "10px",
                background: "#FFEBEE", borderLeft: "3px solid #D32F2F",
                padding: "8px 12px", marginBottom: "6px", borderRadius: "4px",
              }}>
                <span style={{ fontSize: "13px", color: "#333", flex: 1 }}>
                  <strong>{t.teacher}</strong>{t.school ? " — " + t.school : ""}
                  <span style={{ color: "#D32F2F", marginLeft: "8px" }}>Failed</span>
                </span>
                <button
                  onClick={function () { onRetry(t.id); }}
                  style={{
                    background: "#D32F2F", color: "#fff", border: "none",
                    borderRadius: "4px", padding: "4px 10px", fontSize: "11px",
                    cursor: "pointer", fontWeight: 600,
                  }}
                >Retry</button>
              </div>
            );
          })}
        </div>
      )}

      <div style={{ marginBottom: "16px" }}>
        <label style={LABEL_STYLE}>Your Name / Family</label>
        {hasSubmitted ? (
          <div style={{ ...INPUT_STYLE, background: "#fafafa", color: "#555" }}>{fromName}</div>
        ) : (
          <input
            value={fromName}
            onChange={function(e) { onFromNameChange(e.target.value); }}
            placeholder="e.g. The Berardi Family"
            style={INPUT_STYLE}
          />
        )}
      </div>
      <div style={{ marginBottom: "10px" }}>
        <label style={LABEL_STYLE}>To (teacher, staff, or senior name)</label>
        <input
          value={entry.teacher}
          onChange={function(e) { onEntryChange("teacher", e.target.value); }}
          placeholder="e.g. Coach Nichols"
          style={INPUT_STYLE}
        />
      </div>
      <div style={{ marginBottom: "10px" }}>
        <label style={LABEL_STYLE}>School or 2026 Senior</label>
        <select
          value={entry.school}
          onChange={function(e) { onEntryChange("school", e.target.value); }}
          style={{ ...INPUT_STYLE, background: "#fff" }}
        >
          <option value="">Select a school or senior...</option>
          <optgroup label="Schools">
            {SCHOOLS.map(function(s) { return <option key={s} value={s}>{s}</option>; })}
          </optgroup>
          <optgroup label="Senior Tributes">
            {SENIOR_CATEGORIES.map(function(s) { return <option key={s} value={s}>{s}</option>; })}
          </optgroup>
        </select>
      </div>
      <div>
        <label style={LABEL_STYLE}>Your message</label>
        <textarea
          value={entry.message}
          onChange={function(e) { onEntryChange("message", e.target.value); }}
          placeholder="Thank you for..."
          rows={3}
          style={{ ...INPUT_STYLE, resize: "vertical" }}
        />
      </div>
    </div>
  );
}
